import { createFileRoute } from '@tanstack/react-router';

import { QuizItemView } from '#/features/community-hub/components/block-viewers/quiz-item-view';

/**
 * Quiz Content Route
 * Path: /programs/{program}/{module}/{lesson}/quiz/{itemSlug}
 * Shows quiz for a lesson's quiz content block
 */
export const Route = createFileRoute('/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/quiz/$itemSlug')({
  component: QuizContentRoute,
});

function QuizContentRoute() {
  const { itemSlug } = Route.useParams();
  // Keyed so opening another item remounts the view instead of keeping the last item's state.
  return <QuizItemView key={itemSlug} itemSlug={itemSlug} />;
}
